module.exports = __webpack_public_path__ + "img/contact-close.8f0d99da.svg";